import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import GeoUtils from '../geoUtils.js';

export default class NodeCreateCylinder extends Node
{
	constructor(pParent)
	{
		super(pParent);
		
		this.addInput(PARAM_TYPE.FLOAT, 'height', 0.5, { units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'diameter', 0.1, { units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.INTEGER, 'segments', 16, { minValue: 4, maxValue: 32 });
		
		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');	
	}
	
	getType()
	{
		return 'cylinder';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		if(inputValues['height'] <= 0 || inputValues['height'] === Infinity
			|| inputValues['diameter'] <= 0 || inputValues['diameter'] === Infinity
			|| inputValues['segments'] <= 0 || inputValues['segments'] === Infinity)
		return null;

        let pCylinder = BABYLON.MeshBuilder.CreateCylinder(this.getGeneratedMeshName(), { 
			height: inputValues['height'],
			diameter: inputValues['diameter'],
			tessellation: inputValues['segments'],
			sideOrientation: BABYLON.Mesh.FRONTSIDE,
			updatable: true
		}, scene);

		//this.createAndAssignMaterial(pCylinder, scene, new BABYLON.Color3(255.0/255.0, 204/255, 0));
		GeoUtils.applyBoxUVsToMeshes([pCylinder]);
		this.onMeshCreated(pCylinder);

		return [pCylinder];
	}
}
